
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import BaseLayout, { BaseModelProps } from 'src/components/layouts/BaseLayout';

import ATeamSeo from 'src/components-pages/a-team/seo';

import ATeamAnimation from 'src/components-pages/a-team/ATeamAnimation';
import { makeStyles } from '@material-ui/core';
import { useIsMobileSize } from 'src/hooks/useIsMobile';
import { getBaseModels } from 'src/graphql/models/query';

interface Props extends BaseModelProps {}

const useStyles = makeStyles({ root: { overflowX: 'hidden' } });

const ATeam = ({ baseData }: Props) => {
    const classes = useStyles();
    const isMobile = useIsMobileSize();
    return (
        <BaseLayout
            hasFooter={true}
            navVariant={isMobile ? 'dark' : 'monolite'}
            classes={{ root: classes.root }}
            baseData={baseData}>
            <ATeamSeo />
            <ATeamAnimation />
        </BaseLayout>
    );
};

 const _getStaticProps = async () => {
    const baseData = await getBaseModels();
    return {
        props: { baseData },
        revalidate: 100
    };
};

export default ATeam;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/a-team',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  